var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"dual-ring-loader"},[_c('div',{staticClass:"dual-ring-loader__ring",style:({ width: `${_vm.outerSize}px`, height: `${_vm.outerSize}px` })},[_c('div',{staticClass:"dual-ring-loader__inner",style:({ 'border-color': `${_vm.color} transparent`, 'border-width': _vm.borderWidth })})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }